
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
import DsEditor from "@/components/ds-editor/ds-editor.vue";
import { UploadFile } from "@/request/common";
import { EditKepu, GetKepuDetail } from "@/request/content";
@Component({
  components: {
    MainHeader,
    NavLeft,
    DsEditor,
  },
})
export default class ComposeUser extends Vue {
  private data: any = {
    附加参数: {},
  };
  private types: any = [
    "运动康复",
    "睡眠",
    "心理",
    "营养",
    "动脉斑块",
    "冠心病",
    "血管抗衰老",
  ];
  private type: any = "";
  private get user() {
    return this.$store.state.user;
  }
  private forceUpdate() {
    this.$forceUpdate();
  }
  private editorChange(e: any) {
    this.data["正文"] = e;
  }
  private preview() {
    window.open(this.data["封面"]);
  }
  private save() {
    if (!this.data["标题"]) {
      this.$message.warning("请输入标题！");
      return;
    }
    if (this.type == "自定义" && !this.data["正文"]) {
      this.$message.warning("请输入正文！");
      return;
    }
    if (this.type == "自定义" && !this.data["封面"]) {
      this.$message.warning("请上传封面！");
      return;
    }
    if (this.type == "视频号" && !this.data['附加参数']["finderUserName"]) {
      this.$message.warning("请输入视频号id！");
      return;
    }
    if (!this.data["类别"]) {
      this.$message.warning("请选择类别！");
      return;
    }
    const params: any = {
      doctor_id: this.user.user_id,
      kepu_id: this.data.kepu_id,
      标题: this.data["标题"],
      作者: this.data["作者"],
      正文: this.data["正文"],
      封面: this.data["封面"],
      类别: this.data["类别"],
      状态: this.data["状态"] || "未发布",
      附加参数:this.data['附加参数'],
      内容来源: this.type,
    };
    EditKepu(this, params).then((res: any) => {
      this.$message.success("保存成功！");
      this.$router.back();
    });
  }
  private upload(file: any) {
    console.log(file);
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("type", "file");
    form.append("file", fileObj);
    UploadFile(this, form).then((data: any) => {
      this.data["封面"] = data.full_file_url;
      this.forceUpdate();
    });
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        kepu_id: this.data.kepu_id,
      },
    };
    GetKepuDetail(this, params)
      .then((res: any) => {
        loading.close();
        this.data = res;
      })
      .catch(() => {
        loading.close();
      });
  }
  private mounted() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    } else {
      this.type = "自定义";
    }
    if (this.$route.query.id) {
      this.data.kepu_id = this.$route.query.id;
      this.getData();
    }
  }
}
